import { render, staticRenderFns } from "./WaitingListCellRendererWaiting.vue?vue&type=template&id=187667f2&"
import script from "./WaitingListCellRendererWaiting.vue?vue&type=script&lang=js&"
export * from "./WaitingListCellRendererWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports